<template>
  <div>
    <v-container fluid class="pa-0">
      <filter-bar name="home" :filter="getHomeFilter" />
      <slide-show
        :dataArray="_userData.lineCharts"
        v-slot="slotProps"
        v-if="showMobileView && filteredArray.length > 4"
      >
        <Chart
          type="line-chart"
          :data="slotProps.data.data"
          :title="slotProps.data.title"
          :labels="slotProps.data.labels"
        />
      </slide-show>
      <v-row class="d-flex flex wrap justify-center ma-0 mb-5">
        <div
          v-for="(data, i) in filteredArray"
          :key="i"
          :style="cardClass(data)"
          class="ma-2"
        >
          <component
            v-if="
              data &&
                (!showMobileView === data.showOnMobile ||
                  data.showOnMobile === null)
            "
            :is="data.component"
            :type="data.type"
            :data="data.data"
            :options="data.options"
            :secondaryTitle="data.secondaryTitle"
            :labels="data.labels"
            :title="data.title"
            :overdue="data.overdue"
            :yAxis="data.yAxis"
            width="100%"
            :deviceLocations="data.mapData"
            :usageData="data"
            :appUsageData="data"
            :ratingData="ratingData"
            :loading="getLoadingState(data.title)"
            :_deviceLocations="
              _client.client_name === 'shark'
                ? _groupLocations
                : _deviceLocations
            "
            :id="
              data.title != null
                ? data.title
                    .toLowerCase()
                    .split(' ')
                    .join('-')
                : ''
            "
          />
        </div>
      </v-row>
    </v-container>
    <v-layout v-if="!showMobileView && filteredArray.length > 6">
      <locations
        :_deviceLocations="
          _client.client_name === 'shark' ? _groupLocations : _deviceLocations
        "
      />
    </v-layout>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { mapGetters, mapActions, mapMutations } from 'vuex';
import FeatureUsage from './home/FeatureUsage.vue';
import Chart from './charts/Chart.vue';
import Ratings from './home/Ratings.vue';
import AppUsage from './home/AppUsage.vue';
import DeviceMap from './home/DeviceMap.vue';
import NetworkHealth from './home/NetworkHealth.vue';
import CarOverview from './home/CarOverview.vue';
import ScreensOverview from './home/ScreensOverview.vue';
import OneWayRoundTrip from './home/OneWayRoundTrip.vue';
import SlideShow from '@/components/app/SlideShow';
import Locations from '@/components/app/Locations';
import FilterBar from '@/components/app/FilterBar';
import { MobileView } from '@/mixins';

export default {
  data: () => ({
    filteredArray: [],
  }),
  mixins: [MobileView],
  components: {
    AppUsage,
    DeviceMap,
    FeatureUsage,
    Chart,
    Ratings,
    SlideShow,
    Locations,
    FilterBar,
    NetworkHealth,
    CarOverview,
    ScreensOverview,
    OneWayRoundTrip,
  },
  methods: {
    ...mapMutations({
      setHomeFilter: 'filters/setHomeFilter',
    }),
    ...mapActions({
      getDevices: 'maps/getDeviceLocations',
    }),
    cardClass(width) {
      if (width && width.cardWidth && !this.showMobileView) {
        return width.cardWidth;
      }
      if (this.showMobileView) {
        return '';
      }
      return 'width:30%;';
    },
    filterArray() {
      let dataArray = null;
      const newData = JSON.parse(JSON.stringify(this._userData.homePage));
      const lineCharts = JSON.parse(JSON.stringify(this._userData.lineCharts));
      if (!this.showMobileView) {
        newData.pop();
        const newArray = lineCharts.concat(newData);
        dataArray = newArray;
      } else {
        dataArray = newData;
      }
      this.filteredArray = dataArray;
    },
    getLoadingState(title) {
      switch (title) {
        case 'Total Rounds Played':
          return this.loadingStates.roundsPlayed;
        case 'Feature Usage':
          return this.loadingStates.featureUsage;
        case 'App Usage':
          return this.loadingStates.appUsage;
      }
    },
  },
  computed: {
    ...mapGetters({
      _userData: 'home/getUserData',
      _groupLocations: 'maps/getGroupLocations',
      getHomeFilter: 'filters/getFilter',
      _deviceLocations: 'home/getLocations',
      _client: 'account/getCurrentClient',
      ratingData: 'home/getRatingData',
      loadingStates: 'home/getGraphLoadingStates',
    }),
    filterPosition() {
      if (this.showMobileView) {
        return 'd-flex justify-center';
      }
      return 'd-flex justify-start align-center';
    },
  },
  watch: {
    _userData: {
      handler() {
        this.filterArray();
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
